import React from 'react';
import { Modal } from 'antd';

const AlertModal = ({ open, onOk, onCancel, title, content }) => {
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Aceptar"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default AlertModal; 